import { render, staticRenderFns } from "./GBuyerCompanyInfoForm.vue?vue&type=template&id=281e5242&scoped=true&"
import script from "./GBuyerCompanyInfoForm.vue?vue&type=script&lang=ts&"
export * from "./GBuyerCompanyInfoForm.vue?vue&type=script&lang=ts&"
import style0 from "./GBuyerCompanyInfoForm.vue?vue&type=style&index=0&id=281e5242&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281e5242",
  null
  
)

export default component.exports